<template>

    <div class="tool-output-page"
         v-bind:class="[fontFamilyClass, fontSizeClass, nonFirstPageClass]">
        <div class="tool-output-page__page-header">

            <div class="tool-output-page__page-number">
                Page {{ pageNumber }} of {{ pageCount }}
            </div>

            <div class="tool-output-page__branding">
                {{ tool.label }}
                &copy;
                {{ copyrightDate | moment("YYYY") }}
                Jim Wright
            </div>
        </div>

        <slot>
            <!-- content goes here -->
        </slot>

    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'

    export default Vue.extend({
        name: "ToolOutputPage",
        mixins: [ToolMixin],
        props: {
            pageNumber: Number,
            pageCount: Number,
        },
        computed: {
            nonFirstPageClass() {
                return (this.pageNumber > 1 ? 'tool-output-page--non-first-page' : '')
            },
            fontFamilyClass() {
                return 'tool-output-page--font-family-' + this.docData.fontFace
            },
            fontSizeClass() {
                return 'tool-output-page--font-size-' + this.docData.fontSize
            },
            copyrightDate() {
                return new Date()
            },
        }
    })

</script>

<style lang="scss">

    @import 'sass/variables_mixins';

    .tool-output-page {
        @media print {
            break-inside: avoid;
        }
        position: relative;
        display: block;
        width: 100%;
    }

    .tool-output-page--non-first-page {
        @media print {
            break-before: page;
        }
    }

    .tool-output-page__page-header {
        margin: 20px 0;
        padding: 20px 0;
        width: 100%;
        line-height: 2px;
        background-color: $light-neutral-bg;
    }

    .tool-output-page__page-number {
        float: left;
        font-size: 15px;
        font-weight: bold;
        margin-left: 20px;
    }

    .tool-output-page__branding {
        float: right;
        margin-right: 20px;
    }

    .tool-output-page--font-family-sans {
    }

    .tool-output-page--font-family-serif {
        font-family: serif;
    }

    .tool-output-page--font-family-mono {
        font-family: monospace;
    }

    .tool-output-page--font-size-small {
        font-size: 14px;

        h1 {
            font-size: 24px;
        }
        h2 {
            font-size: 20px;
        }

        @media (max-width: 480px) {
            font-size: 8px;
            h1 {
                font-size: 14px;
            }
            h2 {
                font-size: 11px;
            }
        }

        .table-internal, .table {
            th, td, tr {
                font-size: 10px;
            }
        }
    }

    .tool-output-page--font-size-large {
        font-size: 18px;
        h1 {
            font-size: 32px;
        }
        h2 {
            font-size: 24px;
        }

        @media (max-width: 480px) {
            font-size: 10px;
            h1 {
                font-size: 18px;
            }
            h2 {
                font-size: 14px;
            }
        }

        .table-internal, .table {
            th, td, tr {
                font-size: 13px;
            }
        }
    }

</style>
